import Model from '../utils/Model'

class ChargeItemTarget {
  constructor(code, chineseName) {
    this.code = code
    this.chineseName = chineseName
  }
}

export const CODE_NAME = 'ChargeItemTarget'

export const WTDW = new ChargeItemTarget('WTDW', '委托单位')
export const DCDW = new ChargeItemTarget('DCDW', '订舱代理')
export const CYR = new ChargeItemTarget('CYR', '承运人')
export const CAG = new ChargeItemTarget('CAG', '船代')

export const CD = new ChargeItemTarget('CD', '车队')
export const CK = new ChargeItemTarget('CK', '仓库')
export const BGH = new ChargeItemTarget('BGH', '报关行')
export const HYDL = new ChargeItemTarget('HYDL', '海外代理')
export const FYDL = new ChargeItemTarget('FYDL', '发运代理')
export const MTGS = new ChargeItemTarget('MTGS', '码头公司')
export const FHR = new ChargeItemTarget('FHR', '发货人')
export const SHR = new ChargeItemTarget('SHR', '收货人')
export const TZR = new ChargeItemTarget('TZR', '通知人')

export const TRUCK_PLATFORM_99 = new ChargeItemTarget('TRUCK_PLATFORM_99', '99路集卡平台')

export const NBDZKA = new ChargeItemTarget('NBDZKA', '宁波电子口岸')

export const NINGBO_EDI_CENTER = new ChargeItemTarget('NINGBO_EDI_CENTER', '宁波EDI中心')
export const CUSTOMS_INFO_FILE = new ChargeItemTarget('CUSTOMS_INFO_FILE', '报关单')
export const MS = new ChargeItemTarget('MS', '民生')

export const CARRIER = new ChargeItemTarget('CARRIER', '船公司')
export const DESTINATION_AGENT = new ChargeItemTarget('DESTINATION_AGENT', '目的港代理')
export const YITONG_PLATFORM = new ChargeItemTarget('YITONG_PLATFORM', '亿通')
export const INTTRA_PLATFORM = new ChargeItemTarget('INTTRA_PLATFORM', 'INTTRA')
export const CARGOSMART_PLATFORM = new ChargeItemTarget('CARGOSMART_PLATFORM', 'CARGOSMART')
export const YD = new ChargeItemTarget('YD', '壹沓')

export const UPLOAD = new ChargeItemTarget('UPLOAD', '上传')
export const PRINT = new ChargeItemTarget('PRINT', '打印')
export const FREIGHT_INSURANCE = new ChargeItemTarget('FREIGHT_INSURANCE', '货运险投保')
export const AMS_TRADETECH = new ChargeItemTarget('AMS_TRADETECH', 'tradetech')
export const AMS_EFREIGHT = new ChargeItemTarget('AMS_EFREIGHT', 'eFreight')
export const AMS_DECARTS = new ChargeItemTarget('AMS_DECARTS', 'decarts')
export const AMS_TRADETECH_TTI = new ChargeItemTarget('AMS_TRADETECH_TTI', '企泰TTI')
export const AMS_TRADETECH_CUSTOMS = new ChargeItemTarget('AMS_TRADETECH_CUSTOMS', '企泰CUSTOMS')

export const ENS_SEND = new ChargeItemTarget('SendENS', 'ENS')
export const AFR_OTHER = new ChargeItemTarget('SendAFR', 'AFR')
export const ACI_OTHER = new ChargeItemTarget('SendACI', 'ACI')
export const AMS_OTHER = new ChargeItemTarget('SendAMS', 'AMS')
export const ISF_OTHER = new ChargeItemTarget('SendISF', 'ISF')
export const E_MANIFEST_OTHER = new ChargeItemTarget('SendEManifest', 'eManifest')
export const JCL_SEND = new ChargeItemTarget('SendJCL', 'JCL预报')

export const TYPES = [WTDW, DCDW, CYR, CAG, CD, CK, BGH, HYDL, FYDL, MTGS, FHR, SHR, TZR]
export const MODEL_TYPES = [DCDW, CAG, CARRIER, DESTINATION_AGENT, YITONG_PLATFORM, INTTRA_PLATFORM, CARGOSMART_PLATFORM, YD,
  MTGS, TRUCK_PLATFORM_99, NBDZKA, NINGBO_EDI_CENTER, MS, ENS_SEND, FHR, SHR, TZR, AFR_OTHER, ACI_OTHER, AMS_OTHER, ISF_OTHER, E_MANIFEST_OTHER, JCL_SEND]
//		export const TYPES = [WTDW, DCDW,CYR,HYDL];

export const COLUMNS_TYPES = [DCDW, CAG, CARRIER, DESTINATION_AGENT, YITONG_PLATFORM, INTTRA_PLATFORM, CARGOSMART_PLATFORM, MTGS, UPLOAD, PRINT, FREIGHT_INSURANCE, AMS_TRADETECH, AMS_EFREIGHT, AMS_DECARTS, AMS_TRADETECH_TTI, AMS_TRADETECH_CUSTOMS, TRUCK_PLATFORM_99, NBDZKA, NINGBO_EDI_CENTER, CUSTOMS_INFO_FILE, FHR, SHR, TZR]
/**
 *  return null:没找到.
 */
export function getChargeItemTargetByCode(code) {
  return Model.getObjByCode(code, TYPES)
}

export function getChargeItemTargetByCode2(code) {
  return Model.getObjByCode(code, MODEL_TYPES)
}

export function getChargeItemColumns(code) {
  return Model.getObjByCode(code, COLUMNS_TYPES)
}
